/**
 * Overlay Services Data
 *
 * Initial data for weather and data overlay providers.
 * Similar structure to mapHostsData.js but for overlay layers.
 */

const overlayServicesDataVersion = 1;

const overlayServicesData = [
  {
    id: 0,
    slug: 'openweathermap',
    title: 'OpenWeatherMap',
    description: 'Weather overlays: clouds, precipitation, temperature, wind, pressure. Free tier: 60 calls/min.',
    type: 'overlay',
    active: false,
    url: {
      type: 'XYZ',
      template: 'https://tile.openweathermap.org/map/{layer}/{z}/{x}/{y}.png?appid={apikey}'
    },
    apikey: {
      required: true,
      string: '',
      url: 'https://home.openweathermap.org/api_keys',
      text: 'Get your free API key'
    },
    layers: [
      { id: 0, slug: 'clouds_new', title: 'Clouds', active: false, opacity: 0.7 },
      { id: 1, slug: 'precipitation_new', title: 'Precipitation', active: false, opacity: 0.7 },
      { id: 2, slug: 'temp_new', title: 'Temperature', active: false, opacity: 0.7 },
      { id: 3, slug: 'wind_new', title: 'Wind Speed', active: false, opacity: 0.7 },
      { id: 4, slug: 'pressure_new', title: 'Sea Level Pressure', active: false, opacity: 0.7 }
    ],
    attributions: '© <a href="https://openweathermap.org/" target="_blank">OpenWeatherMap</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 1,
    slug: 'rainviewer',
    title: 'RainViewer',
    description: 'Free global weather radar and satellite imagery. No API key required.',
    type: 'overlay',
    active: false,
    url: {
      type: 'XYZ',
      // RainViewer requires fetching current timestamp from their API
      template: 'https://tilecache.rainviewer.com/v2/radar/{timestamp}/256/{z}/{x}/{y}/2/1_1.png',
      timestampApi: 'https://api.rainviewer.com/public/weather-maps.json'
    },
    apikey: {
      required: false,
      string: ''
    },
    layers: [
      { id: 0, slug: 'radar', title: 'Weather Radar', active: false, opacity: 0.7 },
      { id: 1, slug: 'satellite', title: 'Infrared Satellite', active: false, opacity: 0.7 }
    ],
    attributions: '© <a href="https://www.rainviewer.com/" target="_blank">RainViewer</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 2,
    slug: 'msc-geomet',
    title: 'MSC GeoMet (Canada)',
    description: 'Environment Canada weather data: radar, satellite, forecasts. Free, no API key. Best for Canada.',
    type: 'overlay',
    active: false,
    url: {
      type: 'WMS',
      baseUrl: 'https://geo.weather.gc.ca/geomet',
      // WMS requires different handling than XYZ
      wmsParams: {
        SERVICE: 'WMS',
        VERSION: '1.3.0',
        REQUEST: 'GetMap',
        FORMAT: 'image/png',
        TRANSPARENT: true,
        TILED: true
      }
    },
    apikey: {
      required: false,
      string: ''
    },
    layers: [
      { id: 0, slug: 'RADAR_1KM_RRAI', title: 'Radar Precipitation (CA only)', active: false, opacity: 0.6 },
      { id: 1, slug: 'RADAR_1KM_RSNO', title: 'Radar Snow (CA only)', active: false, opacity: 0.6 },
      { id: 2, slug: 'RADAR_COVERAGE_RRAI.INV', title: 'Radar Coverage', active: false, opacity: 0.5 },
      { id: 3, slug: 'GDPS.ETA_TT', title: 'Temperature (GDPS)', active: false, opacity: 0.5 },
      { id: 4, slug: 'GDPS.ETA_HR', title: 'Humidity (GDPS)', active: false, opacity: 0.5 },
      { id: 5, slug: 'GDPS.ETA_WD', title: 'Wind Direction (GDPS)', active: false, opacity: 0.5 },
      { id: 6, slug: 'GDPS.ETA_WSPD', title: 'Wind Speed (GDPS)', active: false, opacity: 0.5 },
      { id: 7, slug: 'ALERTS', title: 'Weather Alerts (CA only)', active: false, opacity: 0.8 }
    ],
    attributions: '© <a href="https://weather.gc.ca/" target="_blank">Environment Canada</a>',
    createdAt: Date.now(),
    updatedAt: null
  }
];

export { overlayServicesData, overlayServicesDataVersion };
